import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { TermsOfUseEn } from './TermsOfUseEn';
import { TermsOfUsePt } from './TermsOfUsePt';

const TermsOfUse = () => {
  const { i18n } = useTranslation();
  const isPt = i18n.language.startsWith('pt');

  return (
    <>
      <Helmet>
        <title>Terms of Use — Dont Tab</title>
        <meta content="Read the terms and conditions for using Dont Tab, your personal productivity dashboard." name="description"
        />
        <link href="https://donttab.com/terms" rel="canonical" />
        <meta content="Terms of Use — Dont Tab" property="og:title" />
        <meta content="https://donttab.com/terms" property="og:url" />
      </Helmet>
      {isPt ? <TermsOfUsePt /> : <TermsOfUseEn />}
    </>
  );
};

export default TermsOfUse;
